// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  text-transform: uppercase;
}

.invent-logo {
  width: 150px;
  margin: 0 auto;
  display: block;
}

.email-input {
  text-transform: lowercase;
}

.custom-logo {
  width: 200px;
  margin: 0 auto;
  display: block;
}

.login-title {
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
  font-size: 0.9em;
  text-transform: uppercase;
}

.login-subtitle,
.input-label-text {
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.8em;
  padding-left: 3px;
}

.not-have-acc {
  position: absolute;
  bottom: 10px;
  text-decoration: none;
}

.timer {
  margin-top: 10px;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
  text-align: center;
}

.custom-input {
  background: #ffffff;
  color: rgba(0, 0, 0, 0.5);
  padding-left: 10px !important;
  padding-top: 0;
  height: 35px;
  float: left;
}

.custom-btn {
  color: rgba(0, 0, 0, 0.65);
  background: #ffffff;
  height: 41px;
  width: 100%;
}

.border-n-shadow {
  border-radius: 20px;
  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);
}

.login-text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  font-size: 1.2em;
}

.login-btn {
  color: #000000;
  font-weight: 300;
  height: 38px;
  font-size: 1em;
  border-radius: 5px;
  padding: 10px;
}

.forgot-password {
  font-size: 0.8em;
  padding-left: 3px;
  text-decoration: underline;
  cursor: pointer;
}

.invalid-code {
  font-size: 0.8em;
  color: #dd2222;
  font-weight: bold;
  text-align: center;
  font-family: "Roobert-Regular";
  margin: 4px 0 0;
}

.timer {
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
}

.term-conditions {
  background-color: transparent;
  border: none;
  font-size: 0.78em;
  display: flex;
  align-items: center;
}

.space-condition {
  padding-left: 10px;
}

.conditions-class {
  font-size: 1em;
  color: #2979FF;
  margin-top: -5px;
  padding: 0;
}

.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.footer-txt {
  font-size: 0.7em;
}

.input-item {
  border: 1.5px solid rgba(0, 0, 0, 0.65);
  color: rgba(0, 0, 0, 0.65);
  border-radius: 5px;
  --background: #ffffff;
  --border-color: transparent;
  --highlight-color-focused: transparent;
  --inner-padding-end: 8px;
  --padding-start: 16px;
  --min-height: 56px;
  transition: border-color 0.2s ease;
}

.input-item.ion-focused {
  border-color: #2979FF !important;
}

.input-item.has-error {
  border-color: #dd2222 !important;
  box-shadow: 0 0 0 1px #dd2222;
}

.input-item.is-valid {
  border-color: #2dd36f !important;
}

.btn-default.loading {
  opacity: 0.8;
  pointer-events: none;
}

.btn-default .align-loader {
  min-height: 0;
  margin: 0;
}

.code-label {
  display: block;
  font-family: "Roobert-Regular";
  font-size: 0.85em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 12px;
}

.code-digit-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 16px;
}

.code-digit-input {
  width: 48px;
  height: 56px;
  text-align: center;
  font-family: "Roobert-Bold";
  font-size: 1.4em;
  border: 1.5px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.65);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
  -moz-appearance: textfield;
}

.code-digit-input::-webkit-outer-spin-button,
.code-digit-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.code-digit-input:focus {
  border-color: #2979FF;
  box-shadow: 0 0 0 3px rgba(41, 115, 162, 0.12);
}

.code-digit-input.filled {
  border-color: #2979FF;
  background: rgba(41, 115, 162, 0.04);
}

.code-digit-input.has-error {
  border-color: #dd2222;
}

.code-digit-input.has-error:focus {
  box-shadow: 0 0 0 3px rgba(240, 65, 65, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/app/loginp/loginp.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,0BAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EAGA,+CAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,uCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,sCAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;EACA,6BAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,8BAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wDAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,8CAAA;AACF;;AAEA;EACE,qBAAA;EACA,oCAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,6CAAA;AACF","sourcesContent":["ion-title {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.invent-logo {\n  width: 150px;\n  margin: 0 auto;\n  display: block;\n}\n\n.email-input {\n  text-transform: lowercase;\n}\n\n.custom-logo {\n  width: 200px;\n  margin: 0 auto;\n  display: block;\n}\n\n.login-title {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  font-size: .9em;\n  text-transform: uppercase;\n}\n\n.login-subtitle,\n.input-label-text {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: .8em;\n  padding-left: 3px;\n}\n\n.not-have-acc {\n  position: absolute;\n  bottom: 10px;\n  text-decoration: none;\n}\n\n.timer {\n  margin-top: 10px;\n  font-size: .8em;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  text-align: center;\n}\n\n.custom-input {\n  background: #ffffff;\n  color: rgba(0, 0, 0, 0.5);\n  padding-left: 10px !important;\n  padding-top: 0;\n  height: 35px;\n  float: left;\n}\n\n.custom-btn {\n  color: rgba(0, 0, 0, 0.65);\n  background: #ffffff;\n  height: 41px;\n  width: 100%;\n}\n\n.border-n-shadow {\n  border-radius: 20px;\n  -webkit-box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);\n  -moz-box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);\n  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);\n}\n\n.login-text {\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 1.2em;\n}\n\n.login-btn {\n  color: #000000;\n  font-weight: 300;\n  height: 38px;\n  font-size: 1em;\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.forgot-password {\n  font-size: .8em;\n  padding-left: 3px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.invalid-code {\n  font-size: 0.8em;\n  color: #dd2222;\n  font-weight: bold;\n  text-align: center;\n  font-family: 'Roobert-Regular';\n  margin: 4px 0 0;\n}\n\n.timer {\n  font-size: 0.8em;\n  font-weight: bold;\n  text-align: center;\n}\n\n.term-conditions {\n  background-color: transparent;\n  border: none;\n  font-size: .78em;\n  display: flex;\n  align-items: center;\n}\n\n.space-condition {\n  padding-left: 10px;\n}\n\n.conditions-class {\n  font-size: 1em;\n  color: #2979FF;\n  margin-top: -5px;\n  padding: 0;\n}\n\n.footer {\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n}\n\n.footer-txt {\n  font-size: .7em;\n}\n\n.input-item {\n  border: 1.5px solid rgba(0, 0, 0, 0.65);\n  color: rgba(0, 0, 0, 0.65);\n  border-radius: 5px;\n  --background: #ffffff;\n  --border-color: transparent;\n  --highlight-color-focused: transparent;\n  --inner-padding-end: 8px;\n  --padding-start: 16px;\n  --min-height: 56px;\n  transition: border-color 0.2s ease;\n}\n\n.input-item.ion-focused {\n  border-color: #2979FF !important;\n}\n\n.input-item.has-error {\n  border-color: #dd2222 !important;\n  box-shadow: 0 0 0 1px #dd2222;\n}\n\n.input-item.is-valid {\n  border-color: #2dd36f !important;\n}\n\n.btn-default.loading {\n  opacity: 0.8;\n  pointer-events: none;\n}\n\n.btn-default .align-loader {\n  min-height: 0;\n  margin: 0;\n}\n\n.code-label {\n  display: block;\n  font-family: 'Roobert-Regular';\n  font-size: 0.85em;\n  color: rgba(0, 0, 0, 0.65);\n  margin-bottom: 12px;\n}\n\n.code-digit-row {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.code-digit-input {\n  width: 48px;\n  height: 56px;\n  text-align: center;\n  font-family: 'Roobert-Bold';\n  font-size: 1.4em;\n  border: 1.5px solid rgba(0, 0, 0, 0.3);\n  border-radius: 5px;\n  background: #ffffff;\n  color: rgba(0, 0, 0, 0.65);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  outline: none;\n  -moz-appearance: textfield;\n}\n\n.code-digit-input::-webkit-outer-spin-button,\n.code-digit-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.code-digit-input:focus {\n  border-color: #2979FF;\n  box-shadow: 0 0 0 3px rgba(41, 115, 162, 0.12);\n}\n\n.code-digit-input.filled {\n  border-color: #2979FF;\n  background: rgba(41, 115, 162, 0.04);\n}\n\n.code-digit-input.has-error {\n  border-color: #dd2222;\n}\n\n.code-digit-input.has-error:focus {\n  box-shadow: 0 0 0 3px rgba(240, 65, 65, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
